import React from 'react';

export function ProgressBar({done, total, bg = ''}:{done:number, total:number, bg?:string}){
    const percentage = total == 0 ? 0 : Math.min(done / total * 100, 100)

    return <div className="progress" style={{height:"6px"}}>
        <div className={`progress-bar ${bg}`} style={{width:`${percentage.toFixed(2)}%`}}></div>
    </div>
}